import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Renderer2,
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import {
  NgbModal,
  NgbModalOptions,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import {
  AuthService,
  CmsService,
  RoutingService,
  WindowRef,
} from '@spartacus/core';
import { StorefrontComponent } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import $ from 'jquery';
import { Observable, Subscription } from 'rxjs';
import { CustomAddToCartService } from './custom-add-to-cart/custom-add-to-cart.service';
import { EmailPopupComponent } from './shared/modules/email-popup/email-popup/email-popup.component';
import { ExternalsiteAlertComponent } from './shared/modules/externalsite-alert/externalsite-alert/externalsite-alert.component';
import { LoactionStripService } from './shared/modules/location-strip/loaction-strip.service';
import { SharedService } from './shared/services/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StorefrontComponent, NgbPopoverModule],
})
export class AppComponent {
  title = 'dzspartacusstore';
  eventReference: any;
  isUserLoggedIn = false;
  pageName: string | undefined;
  pageId: string | undefined;
  modalOption: NgbModalOptions = {};
  emailConsent: any;
  userId: any;
  accountType: any;
  isAsmEnabled: any;
  csAgentAuthSubscription: any;
  isLoggedIn: Observable<boolean>;
  emailConsentEnabled: boolean | undefined;
  accountDataSub: Subscription | undefined;
  constructor(
    private readonly renderer: Renderer2,
    private readonly pageDate: CmsService,
    private readonly authService: AuthService,
    private readonly sharedService: SharedService,
    private readonly router: RoutingService,
    private readonly route: Router,
    private readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private readonly ref: ChangeDetectorRef,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly customAddToCartService: CustomAddToCartService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    protected locationStripService: LoactionStripService,
    private windowRef: WindowRef
  ) {
    this.isLoggedIn = this.authService.isUserLoggedIn();
  }

  ngOnInit(): void {
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        window?.scrollTo(0, 0);
      }
    });
    this.addSnippet();
    this.isLoggedIn.subscribe((resLoggedIn) => {
      const win = this.windowRef.nativeWindow;
      const session = win?.sessionStorage;
      const local = win?.localStorage;

      if (resLoggedIn) {
        this.user.get().subscribe((userRes) => {
          if (userRes !== undefined) {
            const qresult: any = userRes;

            this.emailConsent = qresult?.emailConsent;
            this.userId = qresult?.userName;
            this.accountType = qresult?.accountType;

            session?.setItem('accountType', this.accountType);
            session?.setItem('userId', this.userId);

            const uid = qresult?.uid || this.userId;
            local?.setItem('user_id', uid);
            local?.setItem('user_login_id', this.userId);

            this.csAgentAuthSubscription = this.csAgentAuthService
              .isCustomerEmulated()
              .subscribe((res) => {
                this.isAsmEnabled = res ? res : false;

                if (this.isAsmEnabled) {
                  local?.setItem('user_type', 'sales_rep');
                } else {
                  if (this.accountType === 'DIRECT') {
                    local?.setItem('user_type', 'customer');
                  } else {
                    local?.setItem('user_type', this.accountType);
                  }
                }
              });

            local?.setItem('user_function', qresult?.role);

            this.isUserLoggedIn = true;

            this.pageDate.getCurrentPage().subscribe((res) => {
              this.pageName = res?.name;
              this.pageId = res?.pageId;

              if (res) {
                if (this.pageName === 'Homepage') {
                  this.router.goByUrl('my-account/account-overview');
                } else if (this.pageId === 'LoginPageReference') {
                  this.router.goByUrl('my-account/account-overview');
                }
              }
            });

            if (this.isUserLoggedIn) {
              this.accountDataSub =
                this.locationStripService.userAccountData.subscribe(
                  (accountdata) => {
                    local?.setItem('user_account_id', accountdata?.uid);
                    this.accountDataSub?.unsubscribe();
                  }
                );
            }
          } else {
            this.isUserLoggedIn = false;
            this.emailConsentEnabled = false;
          }
        });
      } else {
        session?.removeItem('userId');
        local?.removeItem('user_login_id');
        local?.removeItem('user_id');
        local?.removeItem('user_type');
        local?.removeItem('user_account_id');
        local?.removeItem('user_function');
      }

      this.ref.detectChanges();
    });

    this.renderer.listen('document', 'click', (event) => {
      $('.SiteLinks').find('a').addClass('login-link');
      if (event.target.classList.contains('close-banner')) {
        const elementArray = document.getElementsByClassName('Section1');
        const displayBanner = document.getElementsByClassName(
          'ContentSlotHeaderBannerOrdersListing'
        );
        const accImpBanner = document.getElementsByClassName(
          'SanofiAccountOverviewBannerSlot'
        );
        for (let item = 0; item < elementArray.length; item++) {
          elementArray[item].className += ' bannerHide';
        }
        for (let item = 0; item < displayBanner.length; item++) {
          displayBanner[item].className += ' bannerHide';
        }
        for (let item = 0; item < accImpBanner?.length; item++) {
          accImpBanner[item].className += ' bannerHide';
        }
      }
      if (event.target.classList.contains('app-navigation-links')) {
        if (event.target.type === 'external') {
          this.eventReference = event.target.rel;
          const modalRef = this.modalService.open(ExternalsiteAlertComponent, {
            windowClass: 'externalsite-modal',
            backdrop: 'static',
            keyboard: false,
          });
          modalRef.componentInstance.eventReference = this.eventReference;
        } else if (event.target.type === 'internal') {
          window?.open(event.target.rel);
        }
      }
      const hamburger = document.getElementsByClassName('cx-hamburger');
      const hideSiteContext = document.getElementsByClassName('SiteContext');
      const hideSiteLink = document.getElementsByClassName('SiteLinks');
      const hideSearchBox = document.getElementsByClassName('SearchBox');
      const hideSiteLogo = document.getElementsByClassName('SiteLogo');
      const hideMiniCart = document.getElementsByClassName('MiniCart');
      const hideSiteLogin = document.getElementsByClassName('SiteLogin');
      const expandedOption = [...hamburger].some((item) =>
        item.classList.contains('is-active')
      );
      const elementsToHide = [
        ...hideSiteContext,
        ...hideSiteLink,
        ...hideSearchBox,
        ...hideSiteLogo,
        ...hideMiniCart,
        ...hideSiteLogin,
      ];
      if (expandedOption) {
        elementsToHide.forEach((element) => {
          element.classList.add('noDisplay');
        });
      } else {
        elementsToHide.forEach((element) => {
          element.classList.remove('noDisplay');
        });
      }
    });
  }
  emailConsentContent() {
    const win = this.windowRef.nativeWindow;
    const session = win?.sessionStorage;

    if (session && !session.getItem('emailPopUp')) {
      this.sharedService.getEmailConsent(this.userId);
      this.emailConsentEnabled = true;

      this.sharedService.emailConsent$.subscribe((result) => {
        if (result) {
          if (
            !this.modalService.hasOpenModals() &&
            result.emailConsentEnabled === true
          ) {
            this.modalOption.backdrop = 'static';
            this.modalOption.keyboard = false;
            this.modalOption.windowClass = 'email-popup-modal';

            const modalRef = this.modalService.open(
              EmailPopupComponent,
              this.modalOption
            );

            modalRef.componentInstance.emailConsentObj = result;
            modalRef.componentInstance.userId = this.userId;

            this.sharedService.emailConsent.next(false);

            session.setItem('emailPopUp', 'true');
          }
        }

        this.ref.detectChanges();
      });
    }
  }
  addSnippet() {
    this.sharedService.getsnippetAPI();
    this.sharedService.snippetData$.subscribe((result) => {
      if (result.snippetConfigs && result.snippetConfigs.length > 0) {
        const snippetCommentStart = this._renderer2.createComment(
          'BEGIN QUALTRICS WEBSITE FEEDBACK SNIPPET'
        );
        const snippetCommentEnd = this._renderer2.createComment(
          'END WEBSITE FEEDBACK SNIPPET'
        );
        for (const config of result.snippetConfigs) {
          const snippetValue = config.value.replace(/\\n/g, '');
          const script = this._renderer2.createElement('script');
          script.type = `text/javascript`;
          script.text = snippetValue;
          this._renderer2.appendChild(this.document.head, snippetCommentStart);
          this._renderer2.appendChild(this.document.head, script);
          const snippetDiv = this._renderer2.createElement('div');
          snippetDiv.id = config.divId;
          const snippetDivComment = this._renderer2.createComment(
            'DO NOT REMOVE-CONTENTS PLACED HERE'
          );
          snippetDiv.appendChild(snippetDivComment);
          this._renderer2.appendChild(this.document.head, snippetDiv);
          this._renderer2.appendChild(this.document.head, snippetCommentEnd);
        }
      }
      this.ref.detectChanges();
    });
  }
}
